import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import NoConditionalForm from "./NoConditionalForm";
import { Form, Table } from "react-bootstrap";
import { useReactToPrint } from "react-to-print";
import { studyOtherSettingsServices } from "../../../../../APIServices/studyOtherSettingsServices";
import { useParams } from "react-router";
import UseToggle from "../../../../../Hooks/UseToggle";
import "../../../../../Styles/Style.scss"

const PrintFormReport = ({
  formName,
  setVersion,
  mainVersion,
  version,
  formFields,
  totalOptionId,
  valueRanderFunction,
  handleNumberChange,
  handleCustomNumberChange,
  handleTextChange,
  handleCustomTextChange,
  handleDateChange,
  handleCustomDateChange,
  handleTimeChange,
  handleCustomTimeChange,
  handleTextareaChange,
  handleDropdownRadioChange,
  handleCustomDropdownRadioChange,
  handleRangeScoreChange,
  handleScaleChange,
  handleUploadChange,
  handleCheckboxChange,
  handleCustomCheckboxChange,
  convertTo24,
  DBPSignatureBy,
  DBPQualityCheck,
  DBPSignatureDT,
  DBPSignatureCode,
  DVSignatureCode,
  DVQualityCheck,
  DVSignatureBy,
  DVSignatureDT,
}) => {
  const GeneratedDate = moment(new Date()).format("DD-MMM-YYYY | HH:mm:ss");
  let { studyId } = useParams();
  const {setToggle} = UseToggle()
  const [errorValidation, setErrorValidation] = useState(false)
  const [reportHeaders, setReportHeaders] = useState([]);
  const [reportFooters, setReportFooters] = useState([]);
  const [hideShowSignature, setHideShowSignature] = useState(false)
  
  const [reportLogo, setReportLogo] = useState("");
  const getReportStudyMetadataData = async () => {
    let data = await studyOtherSettingsServices.getReportStudyMetadataData(studyId)
    let reportData = data?.data || []
    let headerData = reportData?.find(item => item.type === "header")?.headerData || []
    let footerData = reportData?.find(item => item.type === "footer")?.footerData || []
    let logoData = reportData?.find(item => item.type === "logo")
    setReportHeaders(headerData)
    setReportFooters(footerData)
    setReportLogo(logoData)
  }
    
  useEffect(() => {
    getReportStudyMetadataData();
  }, []);
    
  const componentRef = useRef(null);
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `${formName} Report`,
  });

  return (
    <>
      <div className="border-bottom p-2 bg-light">
        <div className="hstack justify-content-between" style={{ height: 30 }}>
          <h6 className="fw-bold mb-0">
            <i className="fa-solid fa-file-prescription me-2"></i>
            {formName}
          </h6>
          <div className="hstack gap-2">
            <Form.Select
              onChange={(e) => setVersion(e.target.value)}
              className="br3"
              style={{ fontSize: 12, width: 100 }}
            >
              {Array.from({ length: mainVersion }, (_, i) => i + 1)
                ?.reverse()
                ?.map((versionNumber, index) => (
                  <option
                    key={index}
                    selected={Number(version) === versionNumber}
                    value={versionNumber}
                  >
                    Version {versionNumber}
                  </option>
                ))}
            </Form.Select>
            <div className="hstack gap-2">
              <button
                className={`updateProfile hstack`}
                onClick={() => setHideShowSignature(!hideShowSignature)}
                title={hideShowSignature ? "Show Signature" : "Hide Signature"}
              >
                {!hideShowSignature ? "Show Signature" : "Hide Signature"}
              </button>
              <button
                className={`updateProfile hstack`}
                onClick={handlePrint}
                title="Print Report"
              >
                Print Report
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="overflow-auto" style={{ height: "calc(100vh - 192px)" }}>
        <div ref={componentRef}>
          <Table className="m-0">
            <thead>
              <div className="headPrint">
                <div className="hstack justify-content-between py-3">
                  <div>
                    {reportHeaders?.length > 0 && reportHeaders?.map((item, index) => (
                      <p key={index} className="m-0 fw-bold fontSize12">{item?.text}</p>
                    ))}
                    <p className="m-0 fw-bold fontSize12">Form Name: {formName}</p>
                    <p className="m-0 fw-bold fontSize12">Form Version: V{version}</p>
                    <p className="m-0 fw-bold fontSize12">Generated On: {GeneratedDate}</p>
                  </div>
                  <img src={reportLogo?.logo || ""} alt="Company Logo" style={{ width: reportLogo?.width || 150, height: reportLogo?.height || 80 }} />
                </div>
              </div>
            </thead>
            <tbody>
              <tr>
                <td className="border-0 p-0">
                  <NoConditionalForm
                    formFields={formFields}
                    setErrorValidation={setErrorValidation}
                    totalOptionId={totalOptionId}
                    valueRanderFunction={valueRanderFunction}
                    handleNumberChange={handleNumberChange}
                    handleCustomNumberChange={handleCustomNumberChange}
                    handleTextChange={handleTextChange}
                    handleCustomTextChange={handleCustomTextChange}
                    handleDateChange={handleDateChange}
                    handleCustomDateChange={handleCustomDateChange}
                    handleTimeChange={handleTimeChange}
                    handleCustomTimeChange={handleCustomTimeChange}
                    handleTextareaChange={handleTextareaChange}
                    handleDropdownRadioChange={handleDropdownRadioChange}
                    handleCustomDropdownRadioChange={ handleCustomDropdownRadioChange}
                    handleRangeScoreChange={handleRangeScoreChange}
                    handleScaleChange={handleScaleChange}
                    handleUploadChange={handleUploadChange}
                    handleCheckboxChange={handleCheckboxChange}
                    handleCustomCheckboxChange={handleCustomCheckboxChange}
                    convertTo24={convertTo24}
                    setToggle={setToggle}
                    DBPSignatureBy={DBPSignatureBy}
                    DBPQualityCheck={DBPQualityCheck}
                    DBPSignatureDT={DBPSignatureDT}
                    DBPSignatureCode={DBPSignatureCode}
                    DVSignatureCode={DVSignatureCode}
                    DVQualityCheck={DVQualityCheck}
                    DVSignatureBy={DVSignatureBy}
                    DVSignatureDT={DVSignatureDT}
                    footer={hideShowSignature}
                  />
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </div>
    </>
  );
};

export default PrintFormReport;
